import { WarningTriangleFilled } from 'AppSrc/core/components/common/svg-icons';


const getFailedToSubmitAlertData = (crqId) => {

  const submitType = crqId ? 'update' : 'create';

  return ({
    className: 'alert-error',
    trueText: 'Refresh',
    falseText: 'Close',
    alertTitle: `Sorry we are unable to ${submitType} your CRQ due to a technical issue. Refreshing the page might help, but please be aware you will loose any changes you've made. If you want to try again without refresh, please just close this message.`,
    Icon: WarningTriangleFilled,
  });
};

export {
  getFailedToSubmitAlertData,
};

